import { Avatar, Card, Flexbox } from '@/components'
import dateMask from '@/lib/masks/date'
import PropTypes from 'prop-types'
import React from 'react'

export default function AuthorCard({ data }) {
  const { author } = data

  return (
    <Card.Base>
      <Card.Header>
        <Flexbox.Columns className="align-center">
          <Flexbox.Column>
            <div className="h6 card-title">Adicionado por</div>
          </Flexbox.Column>
          <Flexbox.Column className="col-auto">
            <i className="fas fa-user-shield" />
          </Flexbox.Column>
        </Flexbox.Columns>
      </Card.Header>
      <Card.Body>
        <Flexbox.Columns className="align-center col-gapless">
          <Flexbox.Column className="col-auto mr-1">
            <Avatar photoURL={author?.photoURL} name={author?.fullName || ''} />
          </Flexbox.Column>
          <Flexbox.Column>
            <div style={{ lineHeight: 1 }}>
              <div><b>{author?.fullName || '-'}</b></div>
              <div><small>{author?.email || '-'}</small></div>
            </div>
          </Flexbox.Column>
          <Flexbox.Column className="col-12 mt-2 text-right">
            <small>Em <b>{dateMask(data.createdAt)}</b></small>
          </Flexbox.Column>
        </Flexbox.Columns>
      </Card.Body>
    </Card.Base>
  )
}

AuthorCard.propTypes = {
  data: PropTypes.objectOf(Object).isRequired,
}
